export default class FontConfig {

    private fontFamily: string;
    private fontStyle: Phaser.Types.GameObjects.Text.TextStyle;

    constructor(fontFamily: any){
        this.fontFamily = fontFamily;
        
        this.fontStyle = {
            fontFamily: this.fontFamily,
            color: "#FFFFFF",
            stroke: "#000000",
            align: "center",
            strokeThickness: 6,
            resolution: window.devicePixelRatio
        };
    }

    /**
     * Crea un nuovo TextStyle indipendente.
     * Tutti i parametri sono opzionali.
     */
    public overrideFont(overrides: Partial<Phaser.Types.GameObjects.Text.TextStyle> = {}): Phaser.Types.GameObjects.Text.TextStyle {
        // deep clone per evitare riferimenti condivisi
        const clonedBase: Phaser.Types.GameObjects.Text.TextStyle =
            typeof structuredClone === "function"
                ? structuredClone(this.fontStyle)
                : JSON.parse(JSON.stringify(this.fontStyle));

        // applica override e restituisce un nuovo oggetto
        return { ...clonedBase, ...overrides };
    }
}